import AccountantDashboard from "views/accountant/AccountantDashboard";
import JournalEntries from "views/accountant/JournalEntries";
import TrialBalance from "views/accountant/TrialBalance";
import ProfitLoss from "views/accountant/ProfitLoss";
import MyLeaveRequests from "views/Rh/MyLeaveRequests";

const accountantRoutes = [
    
  { path: "/dashboard", name: "Dashboard", icon: "ni ni-tv-2 text-primary", component: <AccountantDashboard />, layout: "/accountant", sidebar: true },
  { path: "/journal", name: "Journal", icon: "ni ni-bullet-list-67 text-info", component: <JournalEntries />, layout: "/accountant", sidebar: true },
  { path: "/trial-balance", name: "Trial Balance", icon: "ni ni-chart-bar-32 text-success", component: <TrialBalance />, layout: "/accountant", sidebar: true },
  { path: "/profit-loss", name: "P&L", icon: "ni ni-money-coins text-warning", component: <ProfitLoss />, layout: "/accountant", sidebar: true },
  {
      path: "/my-leaves",
      name: "My Leave Requests",
      icon: "ni ni-calendar-grid-58",
      component: <MyLeaveRequests />,
      layout: "/accountant",
      sidebar: true,
    },
];
export default accountantRoutes;